import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from './router';
import { Provider } from 'react-redux'
import store from './redux/store'
import { LoaderProvider } from './context/LoaderContext';
import { ToastContainer } from 'react-toastify';
import ModalSelectNb, { BenefitSelectedProvider } from './context/BenefitSelectedContext';
import { ProductSelectedProvider } from './context/ProductSelectedContext';
import { UserProvider } from './context/UserDataContext';
import { ClientProvider } from './context/ClientContext';
import { ServiceSelectedProvider } from './context/ServiceSelectedContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoaderProvider>
    <Provider store={store}>
      <ToastContainer />
      <BenefitSelectedProvider>
        <ClientProvider>
          <UserProvider>
            <ServiceSelectedProvider>
              <ProductSelectedProvider>
                <BrowserRouter>
                  <Routes />
                </BrowserRouter>
              </ProductSelectedProvider>
            </ServiceSelectedProvider>
          </UserProvider>
        </ClientProvider>
      </BenefitSelectedProvider>
    </Provider >
  </LoaderProvider>
);